var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypeorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1600 1600",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer101",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229 1470 c-44 -13 -77 -40 -96 -78 -15 -31 -19 -70 -23 -257 -6 -239 -12 -269 -64 -293 -23 -10 -26 -18 -26 -59 0 -40 4 -50 22 -58 12 -6 31 -23 42 -38 19 -26 21 -46 26 -250 4 -200 7 -226 26 -262 30 -57 88 -85 176 -85 l68 0 0 50 0 50 -35 0 c-51 0 -91 24 -104 61 -6 19 -11 108 -11 218 0 102 -5 203 -10 223 -6 20 -25 49 -43 65 l-33 29 24 18 c52 40 62 84 62 294 0 253 12 282 116 282 l34 0 0 50 0 50 -62 -1 c-35 0 -75 -4 -89 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 1431 l0 -48 51 -5 c96 -10 108 -42 109 -311 0 -194 8 -232 55 -263 l26 -17 -30 -31 c-16 -17 -35 -44 -40 -59 -6 -16 -11 -104 -11 -200 -1 -262 -13 -295 -109 -305 l-51 -5 0 -48 0 -49 68 0 c89 0 147 28 176 85 19 36 22 64 26 260 6 239 12 269 64 293 23 10 26 18 26 60 0 42 -3 50 -25 60 -52 24 -59 58 -65 297 -4 197 -7 224 -25 255 -30 52 -93 80 -177 80 l-68 0 0 -49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 1277 c-3 -7 -4 -111 -3 -232 l3 -220 195 0 195 0 0 230 0 230 -193 3 c-150 2 -194 0 -197 -11z m363 -19 c17 -17 17 -389 0 -406 -17 -17 -319 -17 -336 0 -17 17 -17 389 0 406 17 17 319 17 336 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 1200 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 1200 c0 -6 48 -10 125 -10 77 0 125 4 125 10 0 6 -48 10 -125 10 -77 0 -125 -4 -125 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 1100 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 1100 c0 -6 48 -10 125 -10 77 0 125 4 125 10 0 6 -48 10 -125 10 -77 0 -125 -4 -125 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 1000 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 1000 c0 -6 48 -10 125 -10 77 0 125 4 125 10 0 6 -48 10 -125 10 -77 0 -125 -4 -125 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 910 c0 -6 53 -10 140 -10 87 0 140 4 140 10 0 6 -53 10 -140 10 -87 0 -140 -4 -140 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 1060 c0 -6 27 -10 60 -10 l60 0 0 -260 0 -260 -60 0 c-33 0 -60 -4 -60 -10 0 -6 30 -10 70 -10 l70 0 0 280 0 280 -70 0 c-40 0 -70 -4 -70 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 737 c-3 -7 -4 -111 -3 -232 l3 -220 195 0 195 0 0 230 0 230 -193 3 c-150 2 -194 0 -197 -11z m363 -19 c17 -17 17 -389 0 -406 -17 -17 -319 -17 -336 0 -17 17 -17 389 0 406 17 17 319 17 336 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 660 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 660 c0 -6 48 -10 125 -10 77 0 125 4 125 10 0 6 -48 10 -125 10 -77 0 -125 -4 -125 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 560 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 560 c0 -6 48 -10 125 -10 77 0 125 4 125 10 0 6 -48 10 -125 10 -77 0 -125 -4 -125 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 460 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 460 c0 -6 48 -10 125 -10 77 0 125 4 125 10 0 6 -48 10 -125 10 -77 0 -125 -4 -125 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 370 c0 -6 53 -10 140 -10 87 0 140 4 140 10 0 6 -53 10 -140 10 -87 0 -140 -4 -140 -10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeorm);
export default __webpack_public_path__ + "static/media/typeorm.c60ab4e3.svg";
export { ForwardRef as ReactComponent };